import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Card, Divider, Text } from "@nextui-org/react";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import * as Yup from "yup";
import { formatDatesWithCurrent, noop } from "../../../helpers";
import { Checkbox, DateRangeWithCurrent, Input } from "../../controls/formik-wrapped";
import { List } from "./list";
var DEFAULT_VALUE = {
  institute: "",
  focus: "",
  date_range: [],
  is_current: false,
  quick_details: "",
  details: [],
  graduated: false,
  institute_full: "",
  focus_full: "",
  location: "",
  completion: "",
  omit: false
};
var KEYS = Object.freeze(Object.keys(DEFAULT_VALUE));

var compareValues = function compareValues(a, b) {
  if (a === b || !a || !b) return true;
  var matches = KEYS.reduce(function (matched, key) {
    return matched && a[key] === b[key];
  }, true);
  return matches;
};

var aggregateErrors = function aggregateErrors(errors) {
  return Object.values(errors).reduce(function (errs, err) {
    return err ? [].concat(_toConsumableArray(errs), [err]) : errs;
  }, []);
};

var SingleEducation = function SingleEducation(_ref) {
  var initialValue = _ref.initialValue,
      onValueChanged = _ref.onValueChanged,
      setValidateFunction = _ref.setValidateFunction;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setIsValid = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      validReason = _useState6[0],
      setValidReason = _useState6[1];

  var previousValue = useRef(initialValue);
  var validationSchema = useMemo(function () {
    var schema = Yup.object({
      institute: Yup.string().ensure().trim().required(),
      focus: Yup.string().ensure().trim(),
      date_range: Yup.array().ensure().length(2).required(),
      is_current: Yup.bool(),
      quick_details: Yup.string().ensure(),
      details: Yup.array().ensure(),
      graduated: Yup.bool(),
      institute_full: Yup.string().ensure(),
      focus_full: Yup.string().ensure(),
      location: Yup.string().ensure().trim(),
      completion: Yup.string().ensure(),
      omit: Yup.bool()
    });
    return schema;
  }, []);
  useEffect(function () {
    if (isValid === undefined) return;
    if (compareValues(previousValue.current, currentValue)) return;
    previousValue.current = currentValue;

    if (isValid) {
      onValueChanged(currentValue);
    }
  }, [currentValue, isValid, onValueChanged, validReason]);
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValue !== null && initialValue !== void 0 ? initialValue : _objectSpread({}, DEFAULT_VALUE),
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: function onSubmit(_values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;
      setSubmitting(false);
    }
  }, function (_ref3) {
    var isValid = _ref3.isValid,
        values = _ref3.values,
        errors = _ref3.errors,
        validateForm = _ref3.validateForm;
    setValidateFunction === null || setValidateFunction === void 0 ? void 0 : setValidateFunction(validateForm);
    setIsValid(isValid);
    if (isValid && !compareValues(currentValue, values)) setCurrentValue(values);
    var aggregatedErrors = aggregateErrors(errors);
    setValidReason(aggregatedErrors.length ? aggregatedErrors.join("; ") : undefined);
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Input, {
      label: "Institute",
      name: "institute",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "institute",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Degree or Area of Study",
      name: "focus",
      fullWidth: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "focus",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Location",
      name: "location",
      fullWidth: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "location",
      component: "div"
    }), /*#__PURE__*/React.createElement(DateRangeWithCurrent, null), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "date_range",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input.Textarea, {
      label: "Summary",
      name: "quick_details",
      fullWidth: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "quick_details",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Completion Date",
      name: "completion",
      fullWidth: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "completion",
      component: "div"
    }), /*#__PURE__*/React.createElement(Checkbox, {
      label: "Graduated",
      name: "graduated"
    }));
  });
};

var DisplaySingleEducation = function DisplaySingleEducation(_ref4) {
  var initialValue = _ref4.initialValue;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, (initialValue === null || initialValue === void 0 ? void 0 : initialValue.institute) || "Unspecified Institute"), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Text, {
    size: "sm"
  }, initialValue === null || initialValue === void 0 ? void 0 : initialValue.focus), /*#__PURE__*/React.createElement(Text, {
    size: "xs"
  }, formatDatesWithCurrent(initialValue)), /*#__PURE__*/React.createElement(Text, {
    size: "xs"
  }, initialValue !== null && initialValue !== void 0 && initialValue.graduated ? "Graduated" : initialValue === null || initialValue === void 0 ? void 0 : initialValue.completion)));
};

var EditSingleEducationHeader = function EditSingleEducationHeader(_ref5) {
  var initialValue = _ref5.initialValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, (initialValue === null || initialValue === void 0 ? void 0 : initialValue.institute) || "Education"), /*#__PURE__*/React.createElement(Text, {
    size: "xs"
  }, initialValue === null || initialValue === void 0 ? void 0 : initialValue.focus));
};

export var EducationEditor = function EducationEditor(_ref6) {
  var education = _ref6.education,
      onValueChanged = _ref6.onValueChanged;
  return /*#__PURE__*/React.createElement(List, {
    individuallyEdit: true,
    display: DisplaySingleEducation,
    editHeader: EditSingleEducationHeader,
    input: SingleEducation,
    newItem: function newItem() {
      return _objectSpread({}, DEFAULT_VALUE);
    },
    values: education || [],
    onValueAdded: noop,
    onValueChanged: noop,
    onValuesChanged: onValueChanged
  });
};